// DropItem.js
import React, { useEffect, useState } from "react";
import { useDrop } from 'react-dnd';
// import DropItem from './DropItem';
import QmModuleStyle from "../../styles/qm.module.css";
import close_button from '../../../../assets/dnd_close.png';
import dnd_titleInfo from "../../assets/dnd_titleinfo.png";

const DropItems1 = ({defaultDropObj,onDrop ,handleRemoveItem,handleDropSelected,handleItemClick,handleItemKeyup,dragselectionId}) => {
    const [{ isOver }, drop] = useDrop(() => ({
        accept: 'item',
        drop: (defaultDragObj) => onDrop(defaultDragObj.defaultDragObj,defaultDropObj?.id),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    }));
    const [ispopup,setIspopup]=useState(false);
    useEffect(() => {
        // Initialize the popup with manual control
        window.$('.btn-popup').popup({
          on: 'focus',
          constrain: true,
          //onShow: () => console.log('Popup shown'),
          //onHide: () => console.log('Popup hidden')
        });
      }, []);
    const togglePopup = (e,popupIndex) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Toggle the popup visibility
        window.$(`#${popupIndex}`).popup('toggle');
        
        // Check the popup visibility status
        const popup = window.$(`#${popupIndex}`);
        const currNode = document.querySelector(`#${popupIndex} ~ span`);
        
        if (popup.hasClass("visible")) {
            setIspopup(true)
            if (currNode) {
                // Remove aria-hidden="true" and add role="alert"
                currNode.removeAttribute('aria-hidden');
                currNode.setAttribute('role', 'alert');
                currNode.setAttribute('aria-live', 'assertive');
            }
        } else {
            setIspopup(false)
            if (currNode) {
                currNode.setAttribute('aria-hidden', 'true');
                currNode.removeAttribute('role');
                currNode.removeAttribute('aria-live');
            }
        }
    };
    const handleFocus = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.$(`#${e.currentTarget.id}`).popup('show');
        // Check the popup visibility status
        const popup = window.$(`#${e.currentTarget.id}`);
        const currNode = document.querySelector(`#${e.currentTarget.id} ~ span`)
        if (popup.hasClass("visible")) {
            setIspopup(true)
            if(currNode){
                // Remove aria-hidden="true" and add role="alert"
                currNode.removeAttribute('aria-hidden');
                currNode.setAttribute('role', 'alert');
                currNode.setAttribute('aria-live', 'assertive');
            }
        } else {
            if (currNode) {
            setIspopup(false)
            currNode.setAttribute('aria-hidden', 'true');
            currNode.removeAttribute('role', 'alert');
            currNode.removeAttribute('aria-live', 'assertive');
            }
        }

      };
    
      const handleBlur = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.$(`#${e.currentTarget.id}`).popup('hide');
         // Check the popup visibility status
        const popup = window.$(`#${e.currentTarget.id}`);
        const currNode = document.querySelector(`#${e.currentTarget.id} ~ span`)
        if (popup.hasClass("visible")) {
            setIspopup(true)
            if(currNode){
                // Remove aria-hidden="true" and add role="alert"
                currNode.removeAttribute('aria-hidden');
                currNode.setAttribute('role', 'alert');
                currNode.setAttribute('aria-live', 'assertive');
            }
        } else {
            if (currNode) {
            setIspopup(false)
            currNode.setAttribute('aria-hidden', 'true');
            currNode.removeAttribute('role', 'alert');
            currNode.removeAttribute('aria-live', 'assertive');
            }

        }
      };

    return (
        <>
        {
            (defaultDropObj?.title !== "Effect") ? 
            <>
                <div className={`${QmModuleStyle["cause"]}`}>
                {(defaultDropObj?.title === "Measurements" || defaultDropObj?.title === "Environment" || defaultDropObj?.title === "People") ? <div className={`${QmModuleStyle["subcause"]}`}></div> : ''}
                <div className={`${QmModuleStyle["rootcause"]} ${QmModuleStyle[`${defaultDropObj?.color}`]}`}>
                
            <div className={`${QmModuleStyle[`drop-default-text-${defaultDropObj?.title}`]}`} >{defaultDropObj?.title} <a id={`${defaultDropObj?.id}`}  href="javascript:void(0)" className="btn-popup" data-content={defaultDropObj.infopopupMsg} data-position="top center" onFocus={handleFocus}
            onBlur={handleBlur} onKeyUp={ (e)=>{ (e.key =='Enter') && togglePopup(e,defaultDropObj?.id);} }><img src={dnd_titleInfo} alt={"info"} className={"image-popup"} style={{width:'17px',position:'relative',top:'3px'}}   onClick={(e)=>{
                togglePopup(e,defaultDropObj?.id)
            }}/></a><span className={`${QmModuleStyle["sr-only"]}`} aria-hidden="true">{ispopup ? defaultDropObj.infopopupMsg : ''}</span></div>
                <div className={`${QmModuleStyle["droppedArea"]} ${defaultDropObj?.dragItems.length === 0 ? QmModuleStyle["empty"] : ``}`} ref={drop} onClick={ (e)=>{ handleDropSelected(e.target.getAttribute('id'));} } onKeyUp={ (e)=>{ (e.key =='Enter') && handleDropSelected(e.target.getAttribute('id'));} } style={{border: `1px dashed ${isOver ? 'green' : 'black'}`,backgroundColor: `${isOver || dragselectionId != '' ? '#FFB81C' : '#FFFFFF'}`,margin:'0px 3px 5px',padding: '5px 5px 25px 5px',minHeight:'130px',maxHeight:'130px',outlineOffset:'-3px'}} tabIndex={0} id={`${defaultDropObj?.id}`} role="button"> 
                    {/* <DropItem onDrop={handleDrop} id={`${defaultDropObj?.id}`}/> */}
                    {/* {JSON.stringify(selection)} */}
                    <span style={{'font-size':'0px'}} className={``}>{defaultDropObj?.title} Droppable</span>                    
                    {defaultDropObj?.dragItems?.map((item, index,dropId) => (
                    <div key={index}                   
                        className={`${QmModuleStyle["drappedItem"]} ${dragselectionId == item.id ? QmModuleStyle["selected"] : ''}`} id={item.id} onClick={(e)=> {
                            handleItemClick(item.id,e,defaultDropObj?.id)
                        }} onKeyUp={(e)=> {
                           (e.key =='Enter') && handleItemKeyup(item.id,e,defaultDropObj?.id)
                        }} tabIndex={0} role="button" aria-pressed={dragselectionId == item.id ? true : false}>
                                {item?.istrue !== undefined ? (item?.istrue 
                                   ? <span className={`${QmModuleStyle["correct-sign"]}`} aria-label="Correct Option"></span>
                                   : <span className={`${QmModuleStyle["incorrect-sign"]}`} aria-label="Incorrect Option"></span>
                                    ) 
                                    : null
                                }
                    <p aria-label={`${item.title} dropped in ${defaultDropObj?.title} droppable`}>{item.title}</p>
                    <button className={`${QmModuleStyle["dnd_closeIcon"]}`} onClick={
                        (e) => handleRemoveItem(e,index,defaultDropObj)} aria-label="Remove Draggable">
                                <img src={close_button} style={{width: "13px", PointerEvent: "auto"}} aria-hidden="true" role='presentation'/>
                        </button>
                        
                    </div>
                    ))}
                
                </div>

                </div>
                {(defaultDropObj?.title === "Machines" || defaultDropObj?.title === "Materials" || defaultDropObj?.title === "Methods") ? <div className={`${QmModuleStyle["subcause"]}`}></div> : ''}
                </div>
            </> : <>
                {/* <div className={`${QmModuleStyle["defect-spacer-top"]}`}></div> */}
                    <div className={`${QmModuleStyle["defect"]} ${QmModuleStyle[`${defaultDropObj?.color}`]}`}>
                        <div className={`${QmModuleStyle[`drop-default-text-${defaultDropObj?.title}`]}`}><span className={`${QmModuleStyle["Effect-heading"]}`}>{defaultDropObj?.title}</span></div>
                        <div className={`${QmModuleStyle['Effect-Dropped']} ${defaultDropObj?.dragItems.length === 0 ? QmModuleStyle["empty"] : ``}`} ref={drop} onClick={ (e)=>{ handleDropSelected(e.target.getAttribute('id'));} } onKeyUp={ (e)=>{ (e.key == 'Enter') && handleDropSelected(e.target.getAttribute('id'));} }  style={{border: `1px dashed ${isOver ? 'green' : 'black'}`,backgroundColor: `${isOver || dragselectionId != '' ? '#FFB81C' : '#FFFFFF'}`,margin:'0px 4.8px 5px',padding: '5px 5px 25px',minHeight:'130px',maxHeight:'130px',outlineOffset:'-3px'}} tabIndex={0} id={`${defaultDropObj?.id}`} role="button"> 
                        {/* <DropItem onDrop={handleDrop} id={`${defaultDropObj?.id}`}/> */}
                            <span style={{'font-size':'0px'}} className={``}>{defaultDropObj?.title} Droppable</span>
                            {defaultDropObj?.dragItems?.map((item, index,dropId) => (
                            <div key={index}
                                className={`${QmModuleStyle["drappedItem"]} ${dragselectionId == item.id ? QmModuleStyle["selected"] : ''}`} id={item.id} onClick={(e)=> {
                                    handleItemClick(item.id,e,defaultDropObj?.id)
                                }} onKeyUp={(e)=> {
                                    (e.key =='Enter') && handleItemKeyup(item.id,e,defaultDropObj?.id)
                                }} tabIndex={0} role="button" aria-pressed={dragselectionId == item.id ? true : false}>
                                        {item?.istrue !== undefined ? (item?.istrue 
                                           ? <span className={`${QmModuleStyle["correct-sign"]}`} aria-label="Correct Option"></span>
                                           : <span className={`${QmModuleStyle["incorrect-sign"]}`} aria-label="Incorrect Option"></span>) 
                                            : null
                                        }
                                <p aria-label={`${item.title} dropped in ${defaultDropObj?.title} droppable`}>{item.title}</p>
                                <button className={`${QmModuleStyle["dnd_closeIcon"]}`} onClick={
                                    (e) => handleRemoveItem(e,index,defaultDropObj)} aria-label="Remove Draggable">
                                        <img src={close_button} style={{width: "13px", PointerEvent: "auto"}} aria-hidden="true" role='presentation'/>
                                </button>
                                
                            </div>
                            ))} 
                            </div>
                        
                    </div>
                    {/* <div className={`${QmModuleStyle["defect-spacer-bottom"]}`}></div> */}
            </>
        }
    </>
    );
};

export default DropItems1;